import React, { useContext } from "react"
import tw from "twin.macro"
import { css } from "@emotion/react"
import { SeriesInfoSectionProps } from "./SeriesInfoSection.d"
import { getCTALinkValue, parseDisclaimerBlocks } from "../../../../helpers"
import { DisclaimersContext } from "../../../../contexts/Disclaimers"
import { toggleDisclaimersModal } from "../../../../contexts/Disclaimers/actions"
import { Image } from "../../../atoms/Image"
import { ButtonLink } from "../../../atoms/Button"
import { CTA } from "../../../../global"

/**
 *
 * @author Cody
 * @summary
 *
 *
 */

const SeriesInfoSection: React.FC<SeriesInfoSectionProps> = ({
  features,
  sectionTitle,
  paragraphs,
  sectionSubheading,
  subHeadingParagraphs,
  sectionImage,
  ctas,
}) => {
  const [state, modalDispatch] = useContext(DisclaimersContext)

  return (
    <section
      css={[tw`grid grid-cols-1 xl:(grid grid-cols-2)`]}
      aria-label={`${sectionTitle}` + " Section"}
    >
      <section
        css={[tw`col-span-1 text-left p-8`, tw`md:(p-20)`, tw`2xl:(p-40)`]}
      >
        {sectionTitle && (
          <div
            css={[
              tw`text-3xl font-light tracking-widest mb-7`,
              css`
                line-height: 3rem;
              `,
              tw`text-4xl`,
              tw`xl:text-5xl`,
            ]}
          >
            {parseDisclaimerBlocks(sectionTitle, selection =>
              modalDispatch(toggleDisclaimersModal(selection)),
            )}
          </div>
        )}

        {paragraphs &&
          paragraphs.map((paragraph, index) => (
            <div key={index} css={[tw`mb-7`]}>
              {parseDisclaimerBlocks(paragraph, selection =>
                modalDispatch(toggleDisclaimersModal(selection)),
              )}
            </div>
          ))}

        {sectionSubheading && (
          <div
            css={[
              tw`mt-12 text-3xl font-book tracking-widest`,
              tw`md:(text-2xl)`,
            ]}
          >
            {parseDisclaimerBlocks(sectionSubheading, selection =>
              modalDispatch(toggleDisclaimersModal(selection)),
            )}
          </div>
        )}

        {subHeadingParagraphs &&
          subHeadingParagraphs.map((paragraph, index) => (
            <div key={index} css={[tw`mt-5 mb-10`]}>
              {parseDisclaimerBlocks(paragraph, selection =>
                modalDispatch(toggleDisclaimersModal(selection)),
              )}
            </div>
          ))}

        {features && (
          <div css={[tw`grid grid-cols-2 md:(grid-cols-2) gap-8`]}>
            {features.map((feature, index) => (
              <div key={index} css={[tw`flex flex-col`]}>
                <span css={[tw`font-semibold`]}>
                  {parseDisclaimerBlocks(feature.title, selection =>
                    modalDispatch(toggleDisclaimersModal(selection)),
                  )}
                </span>
                <span>
                  {parseDisclaimerBlocks(feature.description, selection =>
                    modalDispatch(toggleDisclaimersModal(selection)),
                  )}
                </span>
              </div>
            ))}
          </div>
        )}
        {ctas && (
          <div css={[tw`flex gap-8 justify-center mt-10 flex-col md:flex-row`]}>
            {ctas?.map((cta: CTA) => {
              return (
                <ButtonLink
                  {...{ [cta?.buttonType]: true }}
                  to={getCTALinkValue(cta)}
                  target={cta?.linkType === "external" ? "_blank" : "_self"}
                  css={[
                    tw`w-full col-span-1 h-full flex justify-center items-center !text-xs !px-2.5 whitespace-nowrap`,
                    tw`md:(w-auto !text-sm !px-4)`,
                  ]}
                  key={cta?.title}
                  analytics-id={
                    cta?.title &&
                    (cta.title.toLowerCase() === "schedule service"
                      ? "zip submit:hero:"
                      : cta.title.toLowerCase() === "view all coupons" ||
                          cta.title.toLowerCase() === "ver más cupones"
                        ? "coupons:opps box:"
                        : cta.title.toLowerCase() === "select your dealer" ||
                            cta.title.toLowerCase() ===
                              "selecciona un concesionario"
                          ? "dealer:opps box:"
                          : null)
                  }
                >
                  {cta?.title}
                </ButtonLink>
              )
            })}
          </div>
        )}
      </section>
      {sectionImage && (
        <div css={[tw``]}>
          <Image
            imageData={sectionImage?.image}
            css={[tw`xl:(h-full object-cover)`]}
          />
        </div>
      )}
    </section>
  )
}

export default SeriesInfoSection
